<template>
  <div>
    <el-form
      ref="form"
      class="form-descriptions"
      :model="formData"
      :rules="rules"
      size="mini"
      label-position="left"
      :disabled="disabled"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_quotationSampleName') || '产品报价名称'"
            prop="quotationSampleName"
          >
            <el-input
              v-model="formData.quotationSampleName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_fabricContent') || '产品报价面料'"
            prop="fabricContent"
          >
            <div class="d-flex">
              <el-input
                v-model="formData.fabricContent"
                type="textarea"
                readonly
                :autosize="{ minRows: 5, maxRows: 10 }"
                style="margin-right: 7px"
              />
              <el-button type="info" @click="editFabricVisible = true">
                {{ $l('btn_editFabric') || '编辑面料' }}
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_trackingMethod') || '报价方式'"
            prop="trackingMethod"
          >
            <dict-select
              v-model="formData.trackingMethod"
              url="/sys/common/dict/system"
              :body="{ dictType: 'quotedMethod' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_trackingCurrencyUnit') || '货币单位'"
            prop="trackingCurrencyUnit"
          >
            <dict-select
              v-model="formData.trackingCurrencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <EditFabric
      ref="editFabric"
      :visible.sync="editFabricVisible"
      :devTrackingQuotationNo="devTrackingQuotationNo"
      @confirm="fabricConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditFabric from '../edit-fabric'
export default {
  components: { EditFabric },
  props: {
    devTrackingQuotationNo: { type: String, default: '' },
    tskInfoNo: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: { fabricContent: '' },
      rules: {
        quotationSampleName: [
          { trigger: 'blur', required: true, message: ' ' },
        ],
        fabricContent: [{ trigger: 'blur', required: true, message: ' ' }],
        trackingMethod: [{ trigger: 'change', required: true, message: ' ' }],
        trackingCurrencyUnit: [
          { trigger: 'change', required: true, message: ' ' },
        ],
      },
      listFabric: [],
      editFabricVisible: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    reload() {
      this.init()
      this.$refs.editFabric.getData()
    },
    async init() {
      this.formData = this.tskInfoNo
        ? await this.getTaskData()
        : await this.getData()
      this.$emit('loaded', this.formData)
    },
    getTaskData() {
      if (!this.tskInfoNo) return {}
      return this.$api
        .customerDevTrackingQuotationDetailTaskApi({
          tskInfoNo: this.tskInfoNo,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
    },
    getData() {
      if (!this.devTrackingQuotationNo) return {}
      return this.$api
        .customerDevTrackingQuotationDetailApi({
          devTrackingQuotationNo: this.devTrackingQuotationNo,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
    },
    fabricConfirm(data) {
      this.listFabric = data
      this.formData.fabricContent = ''
      if (!data?.length) return

      const fabricContent = data
        .sort((a, b) => a.fabricPositionCode - b.fabricPositionCode)
        .map((item) => {
          const { fabricPositionName, fabricContent } = item
          return [fabricPositionName, fabricContent].filter(Boolean).join(': ')
        })
        .join('\n')
      this.formData.fabricContent = fabricContent
    },
    validate() {
      return validate.formValidate([this.$refs.form])
    },
    getFormData() {
      return { ...this.formData, listFabric: this.listFabric }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form.form-descriptions {
    .el-form-item {
      margin-bottom: 0 !important;
      display: flex;
      flex-direction: row;
      font-size: 14px !important;
    }
    .el-form-item .el-form-item__label,
    .el-form-item .el-form-item__content {
      padding: 5px 7px;
      border: 1px solid #ebeef5;
    }
    .el-form-item .el-form-item__label {
      float: none;
      width: 120px;
      color: #909399;
      background-color: #fafafa;
      border-right-color: transparent;
    }
    .el-form-item .el-form-item__content {
      flex-grow: 1;
    }
    .el-row:not(:first-child) {
      .el-form-item .el-form-item__label,
      .el-form-item .el-form-item__content {
        border-top-color: transparent;
      }
    }
  }
}
</style>
